module.exports = __webpack_public_path__ + "static/img/11.8f63fb2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/11.png
// module id = BK4A
// module chunks = 0